import { palette } from "../theme";

export const OPEN_WO_STATUSES = ["NEW", "IN_PROGRESS", "STANDBY", "IN_REVIEW"] as const;
export const CLOSED_WO_STATUSES = ["DONE"] as const;
export const ACTIVE_PROJECT_STATUS = "ACTIVE" as const;
export const TECHNICIAN_GROUP_NAME = "technician";
export const PROJECTS_ENDING_SOON_DAYS = 30;
export const DUE_SOON_DAYS = 7;

export const WO_STATUS_COLORS: Record<string, string> = {
  NEW: palette.dashBlue,
  IN_PROGRESS: palette.dashOrange,
  IN_REVIEW: palette.dashPurple,
  STANDBY: palette.dashRed,
  DONE: palette.dashGreen,
};

export const SERVICE_CHART_COLORS = [
  palette.dashBlue,
  palette.dashGreen,
  palette.dashOrange,
  palette.dashPurple,
  palette.dashRed,
  palette.dashCyan,
] as const;
